import _ from "lodash";
import React from "react";
import { Mixpanel } from "../../mixpanel";
import events from "../../services/events";
import style from "../../styles/instructionview";

export default (props) => {
  function onEnddedVideo() {
    events().trackUserEvent(
      "Video Watched Until End",
      props.customApp ? props.customApp.appId : null,
      props.customApp ? props.customApp.customAppId : null,
      props.instructionId,
      null,
      props.userId,
      null,
      "portal",
      props.customApp ? props.customApp.appInfo.appName : null,
      props.instructionName ? props.instructionName : null,
      null
    );
  }

  function onVideoPlay() {
    events().trackUserEvent(
      "Video Watched",
      props.customApp ? props.customApp.appId : null,
      props.customApp ? props.customApp.customAppId : null,
      props.instructionId,
      null,
      props.userId,
      null,
      "portal",
      props.customApp ? props.customApp.appInfo.appName : null,
      props.instrunctionName ? props.instrunctionName : null,
      null
    );
  }

  const videoStyle = !_.isEmpty(props.style) ? props.style : style;

  return (
    <div style={videoStyle}>
      {props.url && (
        <video
          poster={props.prevUrl}
          preload="metadata"
          controls="controls"
          x-webkit-airplay="allow"
          src={props.url}
          style={videoStyle}
          controlsList="nodownload"
          onEnded={onEnddedVideo}
          onPlay={onVideoPlay}
        ></video>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/InstructionVideo.js